module.exports = __webpack_public_path__ + "static/img/exhibit-4.534d245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/exhibit-4.jpg
// module id = jRfO
// module chunks = 52